<deposit-end-screen-wrapper class="bp-modal">
	<bp-modal-header header>
		<a (click)="close()" right href="javascript:" (keydown.enter)="close()" [tabIndex]="0">
			{{ "close" | translate }}
		</a>
	</bp-modal-header>
	<div content class="end-screen-content">
		<img class="end-screen-img" [src]="failedIco" [alt]="failedIcoAltI18nKey | translate" />
		<div class="end-screen-headline">{{ "deposit_expired" | translate }}</div>
		<p class="end-screen-description">{{ "please_try_again" | translate }}</p>
		<div class="end-screen-buttons-container">
			<button type="button" class="btn btn-primary mod-button-width btn-bold" (click)="tryAgain()">
				{{ "try_again" | translate }}
			</button>
		</div>
	</div>
</deposit-end-screen-wrapper>
